import { WellLocationOnDeckItem } from 'common/types/mix';
import { WellSortMode } from 'common/types/plateAssignments';

/**
 * Sorts a given array of wells by the given well sort mode. Will not
 * modify the input array.
 *
 * @param wells Array of wells to re-order.
 * @param sortMode Well sort mode
 * @returns New array of sorted wells
 */
export function reorderWellLocationOnDeckItem(
  wells: WellLocationOnDeckItem[],
  sortMode: WellSortMode = WellSortMode.BY_ROW,
): WellLocationOnDeckItem[] {
  return [
    ...wells.sort((a: WellLocationOnDeckItem, b: WellLocationOnDeckItem) => {
      return sortMode === WellSortMode.BY_ROW
        ? a.row - b.row || a.col - b.col
        : a.col - b.col || a.row - b.row;
    }),
  ];
}
